import { useState, useEffect } from "react";
export default function IsMobile(breakpoint) {
    if (breakpoint === void 0) { breakpoint = 768; }
    var _a = useState(window.innerWidth < breakpoint), isMobile = _a[0], setIsMobile = _a[1];
    useEffect(function () {
        var handleResize = function () { return setIsMobile(window.innerWidth < breakpoint); };
        window.addEventListener("resize", handleResize);
        return function () { return window.removeEventListener("resize", handleResize); };
    }, [breakpoint]);
    return isMobile;
}
